import { inject, Injectable } from '@angular/core';
import { FormatDateService } from './format-date.service';
import { NgxPermissionsService } from 'ngx-permissions';
import { LABELS } from '@shared/constants';

@Injectable({
	providedIn: 'root'
})
export class HelperMethodsService {

	formatDateService = inject(FormatDateService);
	permissionsService = inject(NgxPermissionsService);

	/**
	 * Converts enums to arrays, usually used for dropdown options.
	 * For proper labels instead of codes, useLabel retrieves the corresponding labels from labels.constants
	 */
	enumToKeyValueArray(enumObj: any, useLabel = false): { code: string; name: string }[] {
		return Object.keys(enumObj).map((code) => ({
			code,
			name: useLabel ? (LABELS[enumObj[code] as keyof typeof LABELS] ?? enumObj[code]) : enumObj[code]
		}));
	}

	recordOptionsToKeyValue(options: Record<any, any>): { value: string; label: string }[] {
		return Object.keys(options).map(key => {
			return {
				label: options[key],
				value: key
			};
		});
	}


	getFileType(filePath: string): string {
		if (typeof filePath !== 'string') return '';

		const lastDotIndex = filePath.lastIndexOf('.');

		if (lastDotIndex === -1 || lastDotIndex === filePath.length - 1) {
			return '';
		}

		return filePath.substring(lastDotIndex + 1).toLowerCase();
	}

	hasPermission(permissions: string[]): boolean {
		const allPermissions = Object.keys(this.permissionsService.getPermissions());
		console.log({permissions, allPermissions, hasPerm: allPermissions.some(perm => permissions.includes(perm))})
		return allPermissions.some(perm => permissions.includes(perm));
	}

	/**
	 *	Custom Format Filters
	 * 	@param formValues: typically the values of formGroup
	 */
	formatFilters(formValues: any): Record<string, string | number | boolean> {
		const filters: Record<string, string | number | boolean> = {};
		const formValue = formValues;

		Object.keys(formValue)
			.forEach((key) => {
				const value = formValue[key];

				if (value === null || value === undefined || value === '') {
					return;
				}

				if (value instanceof Date) {
					// filters[key] = this.formatDateService.formattoLocalDate(value) as string;
					filters[key] = value.toISOString();
					return;
				}

				filters[key] = value;
			});

		return filters;
	}
}
